import { createContext } from 'react'

import { IAuthContextProps } from './types'

export const AuthContext = createContext({} as IAuthContextProps)
